export default __webpack_public_path__ + "static/media/screen5.e350ef6b.png";